import { z } from "zod";

export const displayTypeEnum = z.enum(["collections", "sessions"]);

export type DisplayType = z.infer<typeof displayTypeEnum>;
